module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/自动焊接机.623a87ca.jpg";